import React, { Component } from 'react';
import { Button, Grid, Typography, WithStyles, withStyles } from '@material-ui/core';
import { MyPATDialog } from '../../../common/index';
import { userStyles } from './style';

interface Props extends WithStyles<typeof userStyles> {
    showPopupDialog: boolean,
    classes: any,
    onProceed: Function,
    handleCancelOnPopup: Function,
    contentType: string,
    getDisplayText: Function
}
class ContentTypeToggleDialog extends Component<Props>{
    constructor(props: Props) {
        super(props);
    }

    renderContentTypeTogglePopUp = () => {
        const { showPopupDialog, onProceed, handleCancelOnPopup, classes, contentType, getDisplayText } = this.props;

        return (
            <>
                <MyPATDialog
                    dialogOpen={showPopupDialog}
                    dialogHasActions={true}
                    dialogHeading="Update Confirmation"
                    isAlignCenter={true}
                    customButtonVariant="withoutBorderCloseIcon"
                    onDialogClose={() => handleCancelOnPopup()}
                    isCustomBackground={false}
                    otherDialogProps={{
                        fullWidth: false,
                        maxWidth: false,
                    }}
                >
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        className={classes.saveDialogContainer}
                    >
                        <Grid item className="paraDetails">
                            <Typography align="center">
                                You are enabling {getDisplayText(contentType)} for this course.<br></br>
                                Are you sure, you want to proceed?
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => handleCancelOnPopup()}
                                >
                                    No
                                </Button>
                                &nbsp;&nbsp;
                                 <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { onProceed(true); handleCancelOnPopup(); }}
                                >
                                    Yes, Proceed
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </MyPATDialog>
            </>
        );

    }



    render = () => {
        return (
            this.renderContentTypeTogglePopUp()
        )
    }

}
// @ts-ignore
export default withStyles(userStyles)(ContentTypeToggleDialog);